export default __webpack_public_path__ + "static/media/Screenshot_8.69d493f4.png";